import type { SubdivisionStockRow } from '@eombor/contracts';
import { Button, Dialog } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';
import { LotUsageList } from './LotUsageList.js';

/**
 * «BU MAHSULOTNI KIM OLGAN?» — bitta LOT bo'yicha.
 *
 * Savol qoldiq kartochkasi ustida tug'iladi: odam «3 dona kelgan edi,
 * javonda nega bitta?» deb qaraydi va javob aynan shu yerda, kartochkani
 * tashlab ketmasdan bo'lishi kerak. Ishlatish tarixi sahifasi ham shu
 * ma'lumotni beradi, lekin u YIG'MA: butun bo'lim bo'yicha, kun bo'yicha
 * guruhlangan lenta va kerakli qatorni topish uchun filtr qo'yish kerak.
 *
 * Ro'yxatning o'zi `LotUsageList` da — u RASXOD oynasida ham chiziladi
 * va ikki joyda boshqa-boshqa ko'rinishi odamni chalg'itardi.
 */
export const LotUsersDialog = ({
  row,
  onClose,
}: {
  row: SubdivisionStockRow;
  onClose: () => void;
}) => (
  <Dialog
    open
    onClose={onClose}
    title={row.nomenclatureName}
    description={t('lotUsers.hint', { code: row.code })}
    footer={
      <div className="flex w-full items-center justify-end">
        <Button variant="ghost" onClick={onClose}>
          {t('usage.detailClose')}
        </Button>
      </div>
    }
  >
    <LotUsageList lotId={row.lotId} unit={row.unit} />
  </Dialog>
);
